module.exports = __webpack_public_path__ + "assets/img/juqu_content_4.a3a5ab73.png";